/* Frequently Bought Together — FBT Sprint 29 Apr 2026 */

(function() {
  'use strict';

  const FBT = {
    discounts: window.__FBT_DISCOUNTS || {},

    init() {
      this.container = document.querySelector('.fbt-section');
      if (!this.container) return;

      this.checkboxes = this.container.querySelectorAll('.fbt-section__card-checkbox');
      this.atcBtn = this.container.querySelector('.fbt-section__atc-btn');
      this.totalEl = this.container.querySelector('.fbt-section__total-price-value');
      this.compareEl = this.container.querySelector('.fbt-section__total-compare-value');
      this.savingsEl = this.container.querySelector('.fbt-section__total-savings');

      this.applyDiscountBadges();
      this.bindEvents();
      this.updateTotals();
    },

    applyDiscountBadges() {
      /* For each FBT card (not the main product), check if it has a discount */
      const cards = this.container.querySelectorAll('.fbt-section__card:not(.fbt-section__card--main)');
      cards.forEach(card => {
        const handle = card.dataset.productHandle;
        const discountPct = this.discounts[handle];
        if (!discountPct) return;

        const price = parseFloat(card.dataset.price || 0);
        const discountedPrice = price * (1 - discountPct / 100);

        /* Update the discounted price display */
        const discountedEl = card.querySelector('.fbt-section__card-price--discounted');
        if (discountedEl) {
          discountedEl.textContent = 'Rs. ' + this.formatMoney(discountedPrice);
        }

        /* Show the discount badge */
        const badge = card.querySelector('.fbt-discount-badge');
        if (badge) {
          badge.textContent = discountPct + '% OFF at checkout';
          badge.style.display = 'inline-block';
        }

        /* Store discounted price on the card for total calculation */
        card.dataset.discountedPrice = discountedPrice.toString();
        card.dataset.discountPct = discountPct.toString();
      });
    },

    bindEvents() {
      this.checkboxes.forEach(cb => {
        cb.addEventListener('change', () => this.updateTotals());
      });

      if (this.atcBtn) {
        this.atcBtn.addEventListener('click', (e) => this.addAllToCart(e));
      }
    },

    getSelectedItems() {
      const items = [];
      this.checkboxes.forEach(cb => {
        if (cb.checked) {
          const card = cb.closest('.fbt-section__card');
          const isMain = card.classList.contains('fbt-section__card--main');
          const originalPrice = parseFloat(card.dataset.price || 0);
          const discountedPrice = parseFloat(card.dataset.discountedPrice || 0);

          items.push({
            variantId: card.dataset.variantId,
            price: (discountedPrice > 0 && !isMain) ? discountedPrice : originalPrice,
            originalPrice: originalPrice,
            comparePrice: parseFloat(card.dataset.comparePrice || originalPrice),
            quantity: 1,
            isMain: isMain
          });
        }
      });
      return items;
    },

    updateTotals() {
      const items = this.getSelectedItems();
      /* Total = main product at full price + FBT products at discounted price */
      const total = items.reduce((sum, item) => sum + item.price, 0);
      /* Compare total = all items at original price (no discount) */
      const originalTotal = items.reduce((sum, item) => sum + item.originalPrice, 0);
      const savings = originalTotal - total;

      if (this.totalEl) {
        this.totalEl.textContent = this.formatMoney(total);
      }
      if (this.compareEl) {
        if (originalTotal > total) {
          this.compareEl.textContent = this.formatMoney(originalTotal);
          this.compareEl.parentElement.style.display = '';
        } else {
          this.compareEl.parentElement.style.display = 'none';
        }
      }
      if (this.savingsEl) {
        if (savings > 0) {
          this.savingsEl.textContent = 'You save Rs. ' + this.formatMoney(savings);
          this.savingsEl.style.display = '';
        } else {
          this.savingsEl.style.display = 'none';
        }
      }

      if (this.atcBtn) {
        this.atcBtn.disabled = items.length === 0;
      }
    },

    formatMoney(amount) {
      return amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    async addAllToCart(e) {
      e.preventDefault();
      const items = this.getSelectedItems();
      if (items.length === 0) return;

      this.atcBtn.disabled = true;
      this.atcBtn.textContent = 'Adding...';

      try {
        /* Sort: add-on items first, main product last.
           Shopify cart shows items in reverse-add order (last added = top).
           So main product goes last → appears at the top of cart. */
        const sorted = [...items].sort((a, b) => (a.isMain ? 1 : 0) - (b.isMain ? 1 : 0));
        const payload = {
          items: sorted.map(item => ({
            id: parseInt(item.variantId),
            quantity: item.quantity
          }))
        };

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        if (response.ok) {
          this.atcBtn.textContent = 'Added!';
          /* Open cart drawer if available */
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(() => {
              const openBtn = document.querySelector('[data-cart-drawer-toggle]') ||
                              document.querySelector('.header__icon--cart') ||
                              document.querySelector('a[href="/cart"]');
              if (openBtn) openBtn.click();
            }, 300);
          }

          setTimeout(() => {
            this.atcBtn.textContent = 'ADD TO CART';
            this.atcBtn.disabled = false;
            window.location.reload();
          }, 1500);
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (err) {
        console.error('FBT add to cart error:', err);
        this.atcBtn.textContent = 'Error — Try Again';
        this.atcBtn.disabled = false;
        setTimeout(() => {
          this.atcBtn.textContent = 'ADD TO CART';
        }, 2000);
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => FBT.init());
  } else {
    FBT.init();
  }
})();
